module.exports = __webpack_public_path__ + "static/media/noun-form-1708509-142350.488a1439.svg";